// extracted by mini-css-extract-plugin
export var ad = "style-module--ad--26040";
export var ads = "style-module--ads--447c1";
export var bottomContainer = "style-module--bottomContainer--ddb08";
export var bottomOverflow = "style-module--bottomOverflow--6fd88";
export var contentArea = "style-module--contentArea--d6525";
export var contentAreaInner = "style-module--contentAreaInner--bd6a9";
export var date = "style-module--date--67f8f";
export var dictionary = "style-module--dictionary--7dc07";
export var dictionaryContainer = "style-module--dictionaryContainer--618ca";
export var footer = "style-module--footer--4e0aa";
export var hero = "style-module--hero--b7681";
export var heroImage = "style-module--heroImage--b8196";
export var heroText = "style-module--heroText--4dc9e";
export var heroTextContainer = "style-module--heroTextContainer--f2b4b";
export var image = "style-module--image--da3a1";
export var label = "style-module--label--c86ac";
export var limit = "style-module--limit--6a507";
export var loader = "style-module--loader--e83d8";
export var separator = "style-module--separator--a5e0c";
export var tag = "style-module--tag--5a9c7";
export var tags = "style-module--tags--57ff1";
export var title = "style-module--title--4235b";